import { FC } from "react";

interface GithubRepoBrowserProps {
    repoUrl: string;
}
 
const GithubRepoBrowser: FC<GithubRepoBrowserProps> = ({repoUrl}) => {

    return (
      <>
        {repoUrl.length > 0 && (
          <iframe
            src={repoUrl}
            style={{ width: "100%", height: "90vh" }}
            title="GitHub Repo Browser"
          />
        )}
      </>
    );
}
 
export default GithubRepoBrowser;